<template>
    <div class="peribox">
        <div class="perititle">
            <div>Delivery Agent Log</div>
            <div class="periicons">
                <i class="far fa-sync-alt" @click="refresh"></i>
            </div>
        </div>
        <table class="peritable">
            <tbody>
            <tr>
                <th>Column</th>
                <th>Lead</th>
            </tr>
            <tr v-for="c in columns">
                <th>{{ c }}</th>
                <td>{{ row ? row[c] : '' }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'app_id',
        'delivery_lead_id'
    ],
    data() {
        let columns = [
            'id',
            'job_id',
            'employer_id',
            'application_id',
            'delivery_lead_id',
            'xml_out',
            'xml_in',
            'success',
            'created_at',
            'updated_at',
            'mandrill_id',
            'reject_reason',
            'is_redacted'
        ];
        return {
            row: null,
            columns: columns
        };
    },
    methods: {
        refresh() {
            axios.get(url(`app/test/app/${this.app_id}/delivery-agent-log/${this.delivery_lead_id}`))
                .then((response) => {
                    this.row = response.data.row;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>
